import {NgModel} from './ngModel';

export const Concentration = NgModel.extend({
    _name: 'Concentration',
});
